import LinkIcon from "@/assets/icons/link.svg";
import { useMentionCard } from "@/containers/MentionCard/context";
import {
  EXTERNAL_LINK_COPY_MAP,
  SOURCE_SHORT_NAME,
} from "@/containers/MentionCard/utils/constants";
import { extractHostname } from "@/utils";
import TextButton from "@components/TextButton";
import { i18n } from "@lingui/core";

import styles from "./ExternalLink.module.css";

const ExternalLink: React.FunctionComponent = () => {
  const {
    channel: { channel_type, channel_type_display },
    episode: { public_url },
    mentions,
  } = useMentionCard();
  const mention = mentions[0];

  const getSourceOrHost = () => {
    try {
      if (public_url) {
        return extractHostname(public_url);
      }
      if (SOURCE_SHORT_NAME.indexOf(channel_type) < 0) {
        return extractHostname(mention.url_with_timing);
      } else {
        const source = channel_type_display || channel_type;
        return source.toLowerCase().includes("twitter") ? "X" : source;
      }
    } catch {
      return null;
    }
  };

  const hostname = getSourceOrHost();
  const url = mention?.url_with_timing || public_url;
  const prefix = i18n._(
    EXTERNAL_LINK_COPY_MAP[channel_type] || EXTERNAL_LINK_COPY_MAP.UNKNOWN
  );

  return url && hostname ? (
    <TextButton
      icon={LinkIcon}
      target="_blank"
      href={url}
      className={styles.root}
      data-testid="external-link"
    >
      {`${prefix} ${hostname}`}
    </TextButton>
  ) : null;
};

export default ExternalLink;
